export const replyTemplatesConstants = {
    REPLY_TEMPLATES_SUCCESS: 'REPLY_TEMPLATES_SUCCESS',
    REPLY_TEMPLATES_ERROR: 'REPLY_TEMPLATES_ERROR',
    REPLY_TEMPLATES_REQUEST: 'REPLY_TEMPLATES_REQUEST',
    REPLY_ALL_ACTIVE_TEMPLATES_SUCCESS: 'REPLY_ALL_ACTIVE_TEMPLATES_SUCCESS',
};
